import { memo } from 'react';
import { Category as CategoryInterface } from '../../../interfaces/domain/menu';
import { useCategory } from '../../../hooks/useCategory';
import styles from "./Category.module.scss";

type HomeCategory = { id: string; name: string };

type CategoryUI = {
  id: string;
  name: string;
  icon?: React.ElementType;
};

interface CategoryProps {
  category: CategoryUI;
}


export const Category = memo(({ category }: CategoryProps) => {
  const { isHome, isSelected, handleAction } = useCategory({ category });

  const Icon = category.icon;

  return (
    <div
      onClick={handleAction}
      className={`
        ${styles.buttonGral}
        ${isHome ? styles.homeButton : ''}
        ${isSelected && !isHome ? styles.selected : styles.notSelected}
      `}
    >
      {Icon && <Icon />}
      <p className={styles.category}>{category.name}</p>
    </div>
  );
});